export const frontend = [
  {
    id: 1,
    name: 'HTML',
    logo: 'logos:html-5',
    title: 'HTML',
  },
  {
    id: 2,
    name: 'CSS',
    logo: 'logos:css-3',
    title: 'CSS',
  },
  {
    id: 3,
    name: 'Javascript',
    logo: 'logos:javascript',
    title: 'JavaScript',
  },
  {
    id: 4,
    name: 'Typescript',
    logo: 'logos:typescript',
    title: 'TypeScript',
  },
  {
    id: 5,
    name: 'React',
    logo: 'logos:react',
    title: 'React',
  },
  {
    id: 6,
    name: 'Vue',
    logo: 'logos:vue',
    title: 'Vue',
  },
  {
    id: 7,
    name: 'Angular',
    logo: 'logos:angular',
    title: 'Angular',
  },
  {
    id: 8,
    name: 'Redux',
    logo: 'logos:redux',
    title: 'Redux',
  },
];

export const css = [
  {
    id: 1,
    name: 'daisyUI',
    logo: 'logos:daisyui',
    title: 'DaisyUI',
  },
  {
    id: 2,
    name: 'tailwind',
    logo: 'logos:tailwindcss-icon',
    title: 'Tailwind CSS',
  },
  {
    id: 3,
    name: 'BootStrap',
    logo: 'logos:bootstrap',
    title: 'Bootstrap',
  },
];

export const backend = [
  {
    id: 1,
    name: 'NodeJs',
    logo: 'logos:nodejs',
    title: 'Node.js',
  },
  {
    id: 2,
    name: 'express',
    logo: 'logos:express',
    title: 'Express',
  },
  {
    id: 3,
    name: 'Koa',
    logo: 'logos:koa',
    title: 'Koa',
  },
  {
    id: 4,
    name: 'socket',
    logo: 'logos:socket-io',
    title: 'Socket.io',
  },
  {
    id: 5,
    name: 'JWT',
    logo: 'logos:jwt',
    title: 'JWT',
  },
  {
    id: 6,
    name: 'Redis',
    logo: 'logos:redis',
    title: 'Redis',
  },
];

export const databases = [
  {
    id: 1,
    name: 'SQL',
    logo: 'vscode-icons:file-type-sql',
    title: 'SQL',
  },
  {
    id: 2,
    name: 'PostgreSQL',
    logo: 'logos:postgresql',
    title: 'PostgreSQL',
  },
  {
    id: 3,
    name: 'MongoDb',
    logo: 'logos:mongodb',
    title: 'MongoDB',
  },
];

export const tests = [
  {
    id: 1,
    name: 'cypress',
    logo: 'logos:cypress',
    title: 'Cypress',
  },
  {
    id: 2,
    name: 'Jest',
    logo: 'logos:jest',
    title: 'Jest',
  },
];
